import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Card, CardBody, Col, Container, Row } from 'reactstrap';
import { getPackages } from '../store/actions/discoverActions';
import { AwesomeButton } from 'react-awesome-button';
import 'react-awesome-button/dist/themes/theme-blue.css';
function DiscoverMleiha() {
	const dispatch = useDispatch();
	const { packages } = useSelector(state => state.discover);
	useEffect(() => {
		if (packages.length == 0) {
			dispatch(getPackages());
		}
	}, []);

	return (
		<>
			<Container className='mt-4 mb-5'>
				<Row>
					{packages.length > 0 &&
						packages.map((pack, index) => {
							return (
								pack.package_name != '' &&
								pack.hide == '0' &&
								pack.enable == '1' &&
								pack.checkout.includes('DiscoverShurooq') && (
									<Col
										key={index}
										lg='4'
										md='6'
										className='mt-3'
									>
										<AwesomeButton
											type='secondary'
											className='product__card'
										>
											{pack.package_name}
										</AwesomeButton>
									</Col>
								)
							);
						})}
				</Row>
			</Container>
		</>
	);
}

export default DiscoverMleiha;
